import 'es6-promise/auto';
import axios from 'axios';
import cbClient from "@/utils/cb-client";
import Logger from "@/utils/logger"
import cbStorage from "@/utils/cb-storage";
import reportError from "@/directives/report-error.js"
window.cbStorage = cbStorage;

var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
var eventer = window[eventMethod];
var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

var customerHandle = window.cbStorage.getItem("ch");

var logout = function() {
  var token = window.cbStorage.getItem("cbt");
  window.cbStorage.removeItem("cbt");
  if(token) {
    cbClient.auth_service.logout({}, {token: token});
  }
}

window.cbTimeout = (func, timer) => {
  window.setTimeout(() => {
    try {
      func();
    }
    catch(error) {
      window.logger.e(error);
    }
  }, timer);
}

window.logger = new Logger(Logger.DEBUG, true);
// Vue.use(reportError);


var cbEventHandler = function(e) {
  if(typeof e.data == "object") {
    // TODO check for origin domain
    if(e.data.key == "cb.logging") {
      logger.addMetaData("ch", customerHandle);
      Object.keys(e.data).forEach((k) => {
        if(k != "key") {
          logger.addMetaData(k, e.data[k]);
        }
      });
      logger.logData.logDumper._send();
      logger.logData.meta = {};
    }

    if(e.data.key == "logout") {
      logout();
    }

    if(e.data.key == "cb.preview.email") {
      try {
        window.localStorage.setItem("cb_preview_email", e.data.value);
      }
      catch(error) {

      }
    }
  }
}

// Listen to message from another window
eventer(messageEvent,function(e) {
  try {
    cbEventHandler(e);
  }
  catch(error) {
    // console.log(error);
  }
},false);



// pass info

var passMessage = function(message) {
  if(window.parent != self) {
    window.parent.postMessage(message, '*');
  }
}


var imageUrl = initInfo.image && initInfo.image.url;
var brandColor = initInfo.color;
passMessage({key: "cb.style_config", image_url: imageUrl, color: brandColor})




// WEBPACK FOOTER //
// ./src/connector-main.js